module.exports = __webpack_public_path__ + "img/query-icon-blue.9440cac8.svg";